/* PDP redesign · hero — gallery selection (thumbs, dots, mobile arrows, swipe). */

(function () {
  function initGallery(root) {
    if (root.dataset.pdpHeroInit) return;
    root.dataset.pdpHeroInit = '1';

    const slides = Array.from(root.querySelectorAll('.pdp-hero__main-image-slide'));
    const thumbs = Array.from(root.querySelectorAll('.pdp-hero__thumb'));
    const dots = Array.from(root.querySelectorAll('.pdp-hero__dot'));
    const mainImage = root.querySelector('.pdp-hero__main-image');
    const prevBtn = root.querySelector('.pdp-hero__arrow--prev');
    const nextBtn = root.querySelector('.pdp-hero__arrow--next');

    if (slides.length <= 1) return;

    let current = 0;

    function setActive(index) {
      const i = Math.max(0, Math.min(slides.length - 1, index));
      current = i;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
      thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === i));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
    }

    thumbs.forEach((t, i) => t.addEventListener('click', () => setActive(i)));
    dots.forEach((d, i) => d.addEventListener('click', () => setActive(i)));
    if (prevBtn) prevBtn.addEventListener('click', () => setActive(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => setActive(current + 1));

    // Swipe / drag on the main image — works for touch and mouse.
    if (mainImage) {
      let startX = 0;
      let dx = 0;
      let dragging = false;

      function start(clientX) {
        dragging = true;
        startX = clientX;
        dx = 0;
      }
      function move(clientX) {
        if (!dragging) return;
        dx = clientX - startX;
      }
      function end() {
        if (!dragging) return;
        dragging = false;
        const threshold = 40;
        if (dx > threshold) setActive(current - 1);
        else if (dx < -threshold) setActive(current + 1);
      }

      mainImage.addEventListener('touchstart', e => start(e.touches[0].clientX), { passive: true });
      mainImage.addEventListener('touchmove',  e => move(e.touches[0].clientX),  { passive: true });
      mainImage.addEventListener('touchend',   end);
      mainImage.addEventListener('touchcancel', end);

      mainImage.addEventListener('mousedown',  e => { e.preventDefault(); start(e.clientX); });
      window.addEventListener('mousemove', e => move(e.clientX));
      window.addEventListener('mouseup',   end);
    }
  }

  function initQtyPicker(root) {
    const input = root.querySelector('.pdp-hero__qty-input');
    const buttons = root.querySelectorAll('[data-qty-step]');
    if (!input || !buttons.length) return;
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.qtyStep, 10) || 0;
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function init() {
    document.querySelectorAll('.pdp-hero__gallery').forEach(initGallery);
    document.querySelectorAll('.pdp-hero [data-qty-picker]').forEach(initQtyPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
